import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function EmailDistListEditRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailDistListEdit', {
		url: '/admin/distlist/:id/contacts',
		controllerAs: 'vm',
		controller: EmailDistListEditCtrl,
		templateUrl: '/ng/hub/Email/DistList/Edit/EmailDistListEditCtrl.html?' + window.BUILD,
		permission: ['manage_groups'],
		resolve: {
			$title: () => 'Edit Email Distribution List',
			distlist: ApiResourcify.endpoint('/distribution_lists/:id'),
		},
	});
}

export class EmailDistListEditCtrl {
	constructor(modal, Api, $timeout, distlist) {
		'ngInject';
		// save injections
		this.modal = modal;
		this.Api = Api;
		this.$timeout = $timeout;
		this.distlist = distlist;
		// setup table
		this.filters = {};
		this.columns = [
			{ field: 'email', label: 'Email', sortable: true },
			{ field: 'fname', label: 'First', sortable: true },
			{ field: 'lname', label: 'Last', sortable: true },
			{ field: 'fname_preferred', label: 'Preferred First', sortable: true },
			{ field: 'lname_preferred', label: 'Preferred Last', sortable: true },
		];
		this.actions = [
			{ label: 'Edit', icon: null, callback: this.editContact.bind(this) },
			{ label: 'Remove', icon: null, callback: this.removeContact.bind(this) },
		];
		this.limit = 10;
	}

	addNew() {
		const reload = this.reload.bind(this);
		this.modal
			.state('hub.loggedin.EmailDistListAddUser', {
				params: { id: this.distlist.id },
				heading: `Add Contacts to Distribution List "${this.distlist.name}"`,
				height: 'full',
				width: 800,
			})
			.then(reload, reload);
	}

	importList() {
		const reload = this.reload.bind(this);
		this.modal
			.state('hub.loggedin.EmailDistListImport', {
				params: { id: this.distlist.id },
				heading: `Import Contacts to Distribution List "${this.distlist.name}"`,
				height: 670,
				width: 750,
			})
			.then(reload, reload);
	}

	editContact(contact) {
		const reload = this.reload.bind(this);
		let headingName = `${contact.fname} ${contact.lname}`;

		if (contact.fname_preferred || contact.lname_preferred) {
			headingName += ` (${contact.fname_preferred || contact.fname} ${contact.lname_preferred || contact.lname})`;
		}

		this.modal
			.state('hub.loggedin.EmailContactsEdit', {
				params: { id: contact.id },
				heading: `Edit: ${headingName}`,
				height: 300,
				width: 700,
			})
			.then(reload, reload);
	}

	removeContact(contact) {
		this.Api.delete(`/distribution_lists/${this.distlist.id}/contacts/${contact.id}`).then(() => {
			this.filters.cb = (+new Date() - 1487628121261).toString(36);
		});
	}

	reload() {
		this.$timeout(() => {
			this.filters.cb = (+new Date() - 1487628121261).toString(36);
		});
	}
}
